import { render, staticRenderFns } from "./EditPlumberOrder.vue?vue&type=template&id=82ff1d4a&scoped=true"
import script from "./EditPlumberOrder.vue?vue&type=script&lang=js"
export * from "./EditPlumberOrder.vue?vue&type=script&lang=js"
import style0 from "./EditPlumberOrder.vue?vue&type=style&index=0&id=82ff1d4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ff1d4a",
  null
  
)

export default component.exports